import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-dataset-information',
  templateUrl: './dataset-information.component.html',
  styleUrls: ['./dataset-information.component.scss'],
  standalone: false
})
export class DatasetInformationComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() overlayDisabled = false;

  newDatasetContent = [
    '1. Name the Data Set and give it a description.',
    '2. Add columns to your Data Set in the order you want them displayed.',
    '3. Choose at least one column to use as the default sort order.',
    '4. Optional: Add workflows to the Data Set if you want to restrict the results to specific workflows.',
    '5. Optional: Add filtering to any workflows if you want to filter the data from that workflow that will be included in the Data Set.',
    '6. Optional: Add column(s) to the filter input to allow the user(s) that are using the Data Set to export data to filter the Data Set even further.',
    '7. Save the Data Set.',
    '8. Publish the Data Set when you are ready for it to be used by others.',
    '9. Once configured, utilize the Export Data Set tab in the Data Export Report to run reports from the Data Set.'
  ]

  constructor() { }

  ngOnInit() {
  }
@Input()viewAndEditDatasetInfo?:boolean=false
@Input() mode: 'full' | 'card'  = 'full';
}
